import { triggerBlobDownload } from '@/utils/blobDownload'

const PDF_MAGIC = '%PDF'

export function isPdfBlob(blob: Blob): boolean {
  if (blob.type.toLowerCase().includes('pdf')) {
    return true
  }

  return false
}

async function hasPdfMagicBytes(blob: Blob): Promise<boolean> {
  const headerBuffer = await blob.slice(0, 4).arrayBuffer()
  const header = String.fromCharCode(...new Uint8Array(headerBuffer))
  return header.startsWith(PDF_MAGIC)
}

export async function isPdfContent(blob: Blob): Promise<boolean> {
  if (isPdfBlob(blob)) {
    return true
  }

  return hasPdfMagicBytes(blob)
}

export type ExternalDocumentDownloadResult = 'ok' | 'invalid' | 'error'

export async function downloadExternalDeliveryNoteDocument(
  url: string,
  filename: string
): Promise<ExternalDocumentDownloadResult> {
  try {
    const response = await fetch(url)

    if (!response.ok) {
      return 'error'
    }

    const blob = await response.blob()

    if (!(await isPdfContent(blob))) {
      return 'invalid'
    }

    const pdfBlob = blob.type.toLowerCase().includes('pdf')
      ? blob
      : new Blob([blob], { type: 'application/pdf' })

    triggerBlobDownload(
      pdfBlob,
      filename.endsWith('.pdf') ? filename : `${filename}.pdf`
    )

    return 'ok'
  } catch {
    return 'error'
  }
}
